import { createSlice } from '@reduxjs/toolkit';
import { ConfirmAction, ConfirmState, SetConfirmationConfigAction } from './interface';
import { RootState } from '$store/rootReducer';

const initialState: ConfirmState = {
  isConfirmRequired: false,
  requestConfig: null,
  confirmCode: null,
  confirmationControls: null,
};

export const { reducer, actions } = createSlice({
  name: 'confirm',
  initialState,
  reducers: {
    setConfirmationConfig(state, action: SetConfirmationConfigAction) {
      const { requestConfig, confirmationControls } = action.payload;

      state.isConfirmRequired = true;
      state.requestConfig = requestConfig;
      state.confirmationControls = confirmationControls;
    },
    confirm(state, action: ConfirmAction) {
      state.confirmCode = action.payload;
    },
    reset(state) {
      state.isConfirmRequired = false;
      state.requestConfig = null;
      state.confirmCode = null;
      state.confirmationControls = null;
    },
  },
});

export { reducer as confirmReducer, actions as confirmActions };
export const confirmSelector = (state: RootState) => state.confirm;
